import React, { Fragment } from "react";
import { packClasses } from "Utils";
import { SelectorIcon } from "@heroicons/react/solid";
import { Menu, Transition } from "@headlessui/react";

const variants = {
    sm: "px-4 py-2 md:text-sm font-medium",
    xs: "px-3 py-1.5 text-sm md:text-xs font-medium",
};

const classNames =
    "focus:outline-none relative inline-flex items-center border border-gray-300 bg-white text-gray-700 hover:bg-gray-50 focus:z-10 focus:border-green-500 focus:ring-1 focus:ring-green-500";

function Button(props) {
    const { type, selected, children, ...childProps } = props.children.props;

    return (
        <button
            type={type}
            className={packClasses(
                props.first ? "rounded-l-md" : "-ml-px",
                props.last ? "rounded-r-md" : "",
                classNames,
                variants[props.variant ? props.variant : "sm"],
                selected ? "text-green-600" : ""
            )}
            {...childProps}
        >
            {children}
            <span
                aria-hidden="true"
                className={packClasses(
                    selected ? "bg-green-500" : "bg-transparent",
                    "absolute inset-x-0 bottom-0 h-0.5"
                )}
            />
        </button>
    );
}

function ButtonMenu(props) {
    const { type, selected, children, onClick, buttons, ...childProps } =
        props.children.props;

    return (
        <Menu
            as="div"
            className={packClasses(
                "relative z-auto",
                props.first ? "rounded-l-md" : "-ml-px",
                props.last ? "rounded-r-md" : "",
                "focus:outline-none border border-gray-300 bg-white text-gray-700 hover:bg-gray-50 focus:z-10 focus:border-green-500 focus:ring-1 focus:ring-green-500",
                variants[props.variant ? props.variant : "sm"]
            )}
            {...childProps}
        >
            <Menu.Button className="inline-flex items-center font-medium">
                {children}
                <SelectorIcon className="ml-2 h-4 w-4" />
            </Menu.Button>
            <Transition
                as={Fragment}
                enter="transition duration-100 ease-out"
                enterFrom="transform scale-95 opacity-0"
                enterTo="transform scale-100 opacity-100"
                leave="transition duration-75 ease-out"
                leaveFrom="transform scale-100 opacity-100"
                leaveTo="transform scale-95 opacity-0"
            >
                <Menu.Items className="focus:outline-none absolute left-0 z-50 mt-2 w-56 origin-top-left rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5">
                    {buttons.map((button, index) => (
                        <Menu.Item
                            key={index}
                            className={packClasses(
                                "block w-full px-4 py-2 text-left text-xs font-medium hover:bg-gray-100",
                                button.props.className
                            )}
                        >
                            {button}
                        </Menu.Item>
                    ))}
                </Menu.Items>
            </Transition>
        </Menu>
    );
}

function ButtonGroup(props) {
    // button.type === "button" or function if re
    return (
        <div className="inline-flex flex-wrap rounded-md shadow-sm">
            {props.buttons.map((button, index) =>
                button?.props?.type === "menu" ? (
                    <ButtonMenu
                        key={index}
                        first={index === 0 ? true : false}
                        last={index === props.buttons.length - 1 ? true : false}
                        children={button}
                        variant={props.variant ? props.variant : "sm"}
                    />
                ) : (
                    <Button
                        key={index}
                        first={index === 0 ? true : false}
                        last={index === props.buttons.length - 1 ? true : false}
                        children={button}
                        variant={props.variant ? props.variant : "sm"}
                    />
                )
            )}
        </div>
    );
}

export default ButtonGroup;
